module.exports = __webpack_public_path__ + "static/img/blog_detail_2.b5d789e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/blog_detail_2.png
// module id = aFWX
// module chunks = 8